export default __webpack_public_path__ + "static/media/undraw07.022f1f2d.svg";